import { Component, OnInit } from '@angular/core';
import { IonNav, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.page.html',
  styleUrls: ['./terms.page.scss'],
})
export class TermsPage implements OnInit {

  canGoBack: boolean = false;

  constructor(private navParams: NavParams) { }

  ngOnInit() {
    this.canGoBack = this.navParams.get('canGoBack');
  }

}
